module.exports = __webpack_public_path__ + "static/media/fly0115.3c4d4699.webp";